module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.11444/img/gold-tier-icon.svg"